// extracted by mini-css-extract-plugin
export default {"SendDraftForApprovalButton":"_SendDraftForApprovalButton--caEQ7","Collapsed":"_Collapsed--nyxcc","Expanded":"_Expanded--Jko_l"};